export enum TutorialType {
  DROP_ZONE_HINT = 'DROP_ZONE_HINT',
}

export default TutorialType;
